/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="imagegallerycategory.module.ts" />

module Meevo.Plugins.ImageGalleryCategory {
    class ImageGalleryCategoryController extends Meevo.Components.BaseClasses.DataMaintenanceControllerBase {
        public displayNameColumn = { header: "Display Name", fieldName: 'displayName', sortDirection: Model.SortDirection.Ascending, width: 30 };
        public coColumnsSet = [
            { header: "Category For:", fieldName: 'imageGalleryCategoryEnum', sortDirection: null, width: 50 },
            { header: "Status", fieldName: 'objectState', sortDirection: null, width: 50 }
        ];
      static $inject = [
        "meevo.AppSettings",
        "meevo.components.common.DataService",
        "meevo.components.modal.ModalService",
        "meevo.components.common.IdentityService",
        "meevo.components.logging.LoggingService",
        "meevo.components.common.SecurityService",
        "meevo.components.tracking.TrackingService",
        "$rootScope",
        "$scope",
        "$state",
        "meevo.ContextParams",
        'meevo.components.short-cuts.ShortCutsService',
        "meevo.components.busy.BusyService",
        "$translate",
        "$timeout"];

      constructor(protected appSettings: Meevo.Components.Common.IAppSettings,
        protected dataService: Meevo.Components.BaseClasses.IDataService,
        protected modalService: Meevo.Components.Modal.IModalService,
        protected identityService: Meevo.Components.Common.IIdentityService,
        protected loggingService: Meevo.Components.Logging.ILoggingService,
        protected securityService: Meevo.Components.Common.ISecurityService,
        protected trackingService: Meevo.Components.Tracking.ITrackingService,
        protected $rootScope: angular.IRootScopeService,
        protected $scope: angular.IScope,
        protected $state: any,
        protected contextParams: Meevo.IContextParams,
        protected shortCutsService: Meevo.Components.ShortCuts.IShortCutsService,

        protected busyService: Meevo.Components.Busy.IBusyService,
        protected $translate: angular.translate.ITranslateService,
        protected $timeout: angular.ITimeoutService) {

        super(appSettings, dataService, modalService, identityService, loggingService, $scope, contextParams, $state, $rootScope, shortCutsService);

      }

      /**
     * Creates the context for editing/adding an item.
     * @return {}
     */
      createContext(): void {
        this.busyService.start();
        this.securityService.checkSection(this.meevoSecurityKeys.DATA_IMAGEGALLERYCATEGORY).then(() => {
          this.busyService.stop();
          this.context = new ImageGalleryCategoryContext(this.appSettings, this.dataService, this.modalService, this.identityService, this.loggingService, this.securityService, this.trackingService,this.$translate);
          this.context.activate(this.selectedItemId,null,this.asLocationId);
          this.context.deactivate = () => {
            this.visualState = Model.MaintenanceFormVisualState.Search;
          };
         }).catch(() => {
          this.busyService.stop();
        });
      }
    }

    angular.module("meevo.plugins.imageGalleryCategory")
        .controller("meevo.plugins.imageGalleryCategory.imageGalleryCategoryController", ImageGalleryCategoryController);
}